import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import Skeleton from "@mui/material/Skeleton";
import { type SxProps } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

type HomePageCardProps = {
  title: string | React.ReactNode;
  subheader?: React.ReactNode;
  children: React.ReactNode;
  sxProps?: SxProps;
  loading?: boolean;
};

const HomePageCard = ({ title, subheader, children, sxProps, loading }: HomePageCardProps) => (
  <Card sx={{ display: "flex", flexDirection: "column", ...sxProps }}>
    <CardHeader
      sx={{
        backgroundColor: "general.backgroundDark",
        borderBottomColor: "general.divider",
        borderBottomWidth: 1,
        py: 1,
        borderBottomStyle: "solid",
        ".MuiCardHeader-content": {
          overflow: "hidden",
        },
      }}
      title={
        loading ? (
          <Skeleton
            variant="rectangular"
            width={380}
            height={25}
            sx={{ mb: 1 }}
            data-cy="home-page-card-title-skeleton"
          />
        ) : typeof title === "string" ? (
          <Typography variant="h4" color="text.primary" data-cy="home-page-card-title" lineHeight={1.35}>
            {title}
          </Typography>
        ) : (
          title
        )
      }
      subheader={
        loading ? (
          <Skeleton variant="rectangular" width={380} height={14} data-cy="home-page-card-subheader-skeleton" />
        ) : (
          <Typography variant="body2" color="text.secondary" data-cy="home-page-card-subheader" noWrap>
            {subheader}
          </Typography>
        )
      }
    />
    {children}
  </Card>
);

export default HomePageCard;
